import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { Button } from 'foundations-components/transitional/components/Button';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import { useEffect } from 'react';
import { trackPotentialBannerInteraction } from '../../../utils/ums';
import { getTrackingProperties, tracker } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const url = path => {
  const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
  const isQA = enviro.isQa() || isQAProxy;
  const baseUrl = getFullUrl('app', {
    envOverride: isQA ? 'qa' : 'prod'
  });
  const {
    protocol,
    hostname
  } = parseUrl(baseUrl);
  return buildUrl({
    protocol,
    hostname,
    path
  });
};
const AssignSeatButtonBase = ({
  apiName,
  children,
  uiButtonProps,
  trackingData,
  upgradeConfig,
  level
}) => {
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed assign seat'
    }, getTrackingProperties({
      apiName,
      trackingData
    }), {
      isPrimaryCTA: level === 0,
      isSecondaryCTA: level === 1
    }));
  }, [apiName, trackingData, level]);
  const trackClick = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, getTrackingProperties({
      apiName,
      trackingData
    })));
    tracker.track('interaction', Object.assign({
      action: 'clicked assign seat'
    }, getTrackingProperties({
      apiName,
      trackingData
    }), {
      isPrimaryCTA: level === 0,
      isSecondaryCTA: level === 1
    }));
    if (upgradeConfig) {
      void trackPotentialBannerInteraction(upgradeConfig);
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    href: url(`/settings/${PortalIdParser.get()}/users/seats`),
    external: true,
    onClick: trackClick,
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    }
  }, uiButtonProps, {
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.assignSeat"
    })
  }));
};
export const AssignSeatButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.ASSIGN_SEAT_BUTTON,
  children: /*#__PURE__*/_jsx(AssignSeatButtonBase, Object.assign({}, props))
});